<template>
    <div class="form-sales-land-modal" v-if="salesCard != null && form != null">
        <button class="btn-close-form-modal" @click="closeFormModal()"><svg-icon icon-class="close" className="icon-close"/></button>
        <div class="form-titles" v-if="formVisible">
            <div class="form-bg" :style="'background-image: url(' + salesCard.shablon_drop_modal.form_img + ')'"></div>
            <div class="titles">
                <h3>{{salesCard.shablon_drop_modal.form_title}}</h3>
                <span>{{salesCard.shablon_drop_modal.form_title_desc}}</span>
            </div>
        </div>
        <div class="form-modal-container">
            <form class="form_call-modal">
                <div class="form-in" :class="{fadeOut : !formVisible}" v-if="formVisible">
                    <div class="form-group form-text">
                        <input type="text" name="name" class="form-control" :placeholder="form.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                    </div>
                    <div class="form-group form-phone">
                        <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" :placeholder="form.phone_mask" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                    </div>
                    <VueRecaptcha
                        ref="recaptchaLandModal"
                        @verify="onCaptchaVerified"
                        :sitekey="salesGcap_siteKey"
                        size="invisible"
                    />
                    <div class="btn-send">
                        <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{form.form_sales_promo_btn}}</button>
                        <span class="error-message" v-show="errors.has('name') || errors.has('phone') || errors.has('email')">Заполните все поля</span>\
                    </div>
                </div>
                <div class="successMessage" v-if="!formVisible">
                    <h3>Спасибо! Ваша заявка отправлена.</h3>
                </div>
            </form>
            <div class="privacy-desc" v-if="formVisible">
                <p>
                    <span>{{ salesCard.shablon_form_privacy_desc.one }}</span> 
                    «<span>{{ form.form_sales_promo_btn }}</span>»
                    <span class="two">{{ salesCard.shablon_form_privacy_desc.two }}</span>
                    <span><a href="https://sales.bazis.kz/privacy-policy" target="_blank">{{ salesCard.shablon_form_privacy_desc.word }}</a></span>
                    <span class="three">{{ salesCard.shablon_form_privacy_desc.three }}</span>
                </p>
            </div>
            <div class="to-many-requests-msg" v-if="toManySendingMsg">
                <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
                <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
                <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
            </div>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import cookie from 'vue-cookie'
    import {mapGetters} from 'vuex'
    import { VueRecaptcha } from 'vue-recaptcha';
    export default {
        name: 'FormConsultLandModal',
        data () {
            return {
                globalLang: window.GlobalLang, 
                toManySendingMsg: false,
                phone: '',
                name: '',
                quest: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                errorMsg: false,
                currentPhone: null,
                projectHost: window.host,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                }
            }
        },
        components: {
            MaskedInput,
            VueRecaptcha,
        },
        computed: mapGetters({
            form: 'loadForms',
            salesCard: 'loadSalesCardContent',
            saleItem: 'loadSaleCardItem',
            salesGcap_siteKey: 'loadGcap_sitekey',
        }),
        methods: {
            onCaptchaVerified(response) {
                let submissionCounter = localStorage.getItem('shablonformPage_submissionCounter') || 0;
                let lastSubmissionTime = localStorage.getItem('shablonformPage_lastSubmissionTime') || 0;
                var currentMinutes = this.getCurrentMinutes();
                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    console.log('Превышен лимит отправок формы. Пожалуйста, подождите некоторое время.');
                    return;
                }
                // console.log(response)
                console.log('start sending verify is complete');
                var querystring = require('querystring');
                var data = {
                    'name': this.name,
                    'phone': this.phone,
                    'project' : this.saleItem.project_name.slug,
                    'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ==',
                };
                if (window.host == 'qazyna') {
                    data.project = this.saleItem.project_name.slug.charAt(0).toUpperCase() + this.saleItem.project_name.slug.slice(1);
                }
                this.formVisible = false;
                // console.log(data)
                axios.post('https://admin.sales.bazis.kz/server/form-call.php', querystring.stringify(data))
                .then(() => {
                    submissionCounter++;
                    localStorage.setItem('shablonformPage_submissionCounter', submissionCounter);
                    localStorage.setItem('shablonformPage_lastSubmissionTime', currentMinutes);
                    dataLayer.push({'event' : 'form_sent'})
                })
                .catch(error => {
                    console.error('Form submission error:', error);
                });
            },
            sendData() {
                this.$validator.validate().then(result => {
                    if(result) {
                        console.log('all ok')
                        this.$refs.recaptchaLandModal.execute();
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            closeFormModal() {
                cookie.set(window.host + '_form_land_modal_timer', true, { expires: this.salesCard.shablon_drop_modal.minutes + 'm' });
                this.$store.commit('Open_FormLandModal', false);
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-land-modal-s.scss';
</style>